/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import SelectCustomer from './SelectCustomer';
import Product from '@/pages/repairManagement/product.vue';
import AddProduct from '@/pages/repairManagement/addProduct.vue';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import PopupRadio from "vux/src/components/popup-radio/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Datetime from "vux/src/components/datetime/index.vue"; // this line is trasformed by vux-loader
import XSwitch from "vux/src/components/x-switch/index.vue"; // this line is trasformed by vux-loader
import ChinaAddressV4Data from "vux/src/datas/china_address_v4.json"; // this line is trasformed by vux-loader
import XAddress from "vux/src/components/x-address/index.vue"; // this line is trasformed by vux-loader
import XTextarea from "vux/src/components/x-textarea/index.vue"; // this line is trasformed by vux-loader
import Checklist from "vux/src/components/checklist/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import ImgUpload from '@/components/ImgUpload';
import CustomFormList from '@/components/CustomFormList';
import SmyMapAddress from '@/components/CustomFormList/SmyMapAddress';
import CustomFormNode from '@/components/CustomFormList/CustomFormNode';
import { apiorderbashinfo, apiappointorder,
// 新建工单
apisystemsettingByCode, apiUpdateName, apicorporation, getV2FiledSortTmplFieldList, apiproject, getCustomerProductDetail } from '@/api';
import { titleRuleSystemFieldList, priorityList } from '@/constant';
import utils from '@/utils/utils';
import SinglePicker from '@/components/Base/SinglePicker';
// import SelectCustomerProductModal from '@/components/SelectCustomerProductModal'
import { getCache as _getCache, setCache, removeCache } from '@/components/CacheFormComponentFunc.js';
import Alert from '@/components/Alert.vue';
import AddFault from './AddFault';
export default {
  name: 'Appointment',
  components: {
    AddFault: AddFault,
    AddProduct: AddProduct,
    Alert: Alert,
    Product: Product,
    SinglePicker: SinglePicker,
    SelectCustomer: SelectCustomer,
    CustomFormNode: CustomFormNode,
    CustomFormList: CustomFormList,
    XInput: XInput,
    XButton: XButton,
    Group: Group,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    PopupRadio: PopupRadio,
    Datetime: Datetime,
    XSwitch: XSwitch,
    XAddress: XAddress,
    Checklist: Checklist,
    ImgUpload: ImgUpload,
    XTextarea: XTextarea,
    SmyMapAddress: SmyMapAddress,
    Cell: Cell,
    CellBox: CellBox
    // CheckOrderTag,
    // CheckProduct,
    // Tags
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    id: [String, Number],
    formData: {
      type: Object
    },
    productId: {
      type: String,
      default: ''
    },
    cpId: {
      type: [String, Number],
      default: ''
    },
    oid: {
      type: [String, Number],
      default: ''
    },
    shopId: {
      type: [String, Number],
      default: ''
    },
    shopOrderId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      objectCustomerProductions: [],
      currentProductIndex: 0,
      isShowAddFault: false,
      hasCache: false,
      isShowProduct: false,
      customerPro: [],
      isShowSelectCustomerProductModal: false,
      isShowCustomerInput: 0,
      custom_name: '',
      isShowSelectCustomer: false,
      customerList: [],
      fieldListBeta: [],
      productMap: {},
      OrderDefaultAddress: [],
      isShowPriority: 0,
      priority: [],
      priorityList: priorityList,
      ChinaAddressV4Data: ChinaAddressV4Data,
      titleRuleSystemFieldList: titleRuleSystemFieldList,
      serviceName: '',
      productList: [],
      changeAddressList: [],
      // 切换地址列表
      isEdit: false,
      btnLoading: false,
      isShowChangeAddress: true,
      // 切换地址弹窗
      titleRule: '',
      // 标题规则
      template: {},
      changeAddressId: '',
      // 系统字段
      systemFields: {
        EstimateCompleteTime: '',
        fk_t_customer_id: '',
        title: '',
        detail_desc: '',
        custom_name: '',
        custom_phone: '',
        custom_apply_time: '',
        prov_id: '',
        city_id: '',
        district_id: '',
        street_id: '',
        custom_detail_addr: '',
        custom_latitude: '',
        custom_longitude: '',
        map_name: '',
        gps_addr: '',
        image_descri_list: [],
        address_type: 1,
        productFileList: []
      },
      customFields: [],
      defaultCode: [],
      fieldList: [],
      // checkorderTagshow: false, // 工单标签弹窗
      // checkProductShow: false, // 产品弹窗
      isProductionFromcustomer: 0 // 是否开启客户产品档案
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    objectCustomerProductionsIndexObj: function objectCustomerProductionsIndexObj() {
      return this.objectCustomerProductions[this.currentProductIndex];
    },
    orderTmpType: function orderTmpType() {
      var type = 2;
      return type; // 工单模板类型 1 普通工单 2 产品类工单
    },
    // 标题规则
    orderTitle: function orderTitle() {
      var _this = this;
      var lPositions = [];
      var lPos = this.titleRule.indexOf('{');
      while (lPos > -1) {
        lPositions.push(lPos);
        lPos = this.titleRule.indexOf('{', lPos + 1);
      }
      var rPositions = [];
      var rPos = this.titleRule.indexOf('}');
      while (rPos > -1) {
        rPositions.push(rPos);
        rPos = this.titleRule.indexOf('}', rPos + 1);
      }
      if (lPositions.length === rPositions.length) {
        var keyArr = [];
        lPositions.forEach(function (val, index) {
          var key = _this.titleRule.substring(lPositions[index] + 1, rPositions[index]);
          keyArr.push(key);
        });
        return keyArr;
      }
      return '';
    },
    // 监听标题规则配置的字段
    watchSystemKey: function watchSystemKey() {
      var _this2 = this;
      var obj = {};
      if (this.orderTitle) {
        this.orderTitle.forEach(function (item) {
          if (item.indexOf('s|') !== -1) {
            var key = item.substring(2);
            _this2.titleRuleSystemFieldList.forEach(function (item2) {
              if (item2.key === key) {
                obj[item2.obj] = _this2.systemFields[item2.obj];
              }
            });
          }
        });
      }
      return obj;
    }
  }),
  watch: {
    changeAddressId: function changeAddressId(val) {
      if (val) {
        var data = this.changeAddressList.find(function (item) {
          return item.id === val;
        });
        if (Object.keys(data).length > 0) {
          this.systemFields.address_type = data.address_type;
          this.systemFields.custom_detail_addr = data.detail_addr;
          this.systemFields.custom_latitude = data.latitude;
          this.systemFields.custom_longitude = data.longitude;
          this.systemFields.prov_id = data.prov_id;
          this.systemFields.city_id = data.city_id;
          this.systemFields.district_id = data.district_id;
          this.systemFields.map_name = data.map_name;
          this.systemFields.gps_addr = data.gps_addr;
          // 修改默认地址
          this.defaultCode = [data.prov_id + '', data.city_id + '', data.district_id + ''];
        }
      }
    },
    // 监听系统字段
    watchSystemKey: {
      handler: function handler(val, oldVal) {
        if (this.titleRule) {
          this.titleRuleFunc();
        }
      },
      deep: true
    },
    customFields: {
      handler: function handler() {
        if (this.titleRule && /{c|\d}/.test(this.titleRule)) {
          this.titleRuleFunc();
        }
      },
      deep: true
    },
    // 编辑工单产品回显
    productList: function productList(val) {
      if (val) this.systemFields.productId = val.map(function (item) {
        return item.id;
      });
    },
    defaultCode: function defaultCode(v) {
      if (v && v.length) {
        if (v[0]) {
          this.systemFields.prov_id = v[0];
        }
        if (v[1]) {
          this.systemFields.city_id = v[1];
        }
        if (v[2]) {
          this.systemFields.district_id = v[2];
        }
        if (v[3]) {
          this.systemFields.street_id = v[3];
        }
      }
    },
    cacheKey: function cacheKey() {
      return "Cache_Order_".concat(this.id, "_").concat(this.user.id);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('globalStore', ['_user', '_pageReload'])), {}, {
    handleBackFault: function handleBackFault(arr) {
      this.objectCustomerProductions[this.currentProductIndex].faults = arr;
    },
    handleEditFault: function handleEditFault(index) {
      this.currentProductIndex = index;
      this.isShowAddFault = true;
    },
    getCustomerPro: function getCustomerPro(customerPro) {
      console.log('AutoConsole: getCustomerPro -> e', customerPro);
      this.objectCustomerProductions.push({
        customerProductionId: customerPro.customerProId,
        productName: customerPro.productName,
        production_sn: customerPro.productionSn,
        faults: []
      });
      this.currValue = false;
    },
    tempSave: function tempSave() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setCache(_this3.cacheKey, _objectSpread(_objectSpread({}, _this3.systemFields), {}, {
                  customField: _this3.customFields,
                  priority: _this3.priority
                }));
                _this3.$vux.toast.text(i18n.tc("547"));
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearCache: function clearCache() {
      removeCache(this.cacheKey);
      this.hasCache = false;
    },
    getCache: function getCache() {
      var _this4 = this;
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        clear: false
      };
      _getCache(this.cacheKey, this.fieldListBeta, function (e) {
        _this4.systemFields = e;
        _this4.priority = e.priority;
        _this4.defaultCode = [_this4.systemFields.prov_id, _this4.systemFields.city_id, _this4.systemFields.district_id, _this4.systemFields.street_id];
      }, function (e) {
        _this4.fieldListBeta = e;
      });
      setTimeout(function () {
        if (opt.clear) _this4.clearCache();
      }, 500);
    },
    replaceMultiImg: function replaceMultiImg(urls) {
      if (!urls) return '';
      var urlArr = urls.split(',');
      return urlArr[0];
    },
    onSelectCustomer: function onSelectCustomer(id, name) {
      this.custom_name = name;
      this.systemFields.fk_t_customer_id = id;
    },
    onCustomField: function onCustomField(value, index) {
      this.$set(this.customFields, index, value);
    },
    initFieldList: function initFieldList(id) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$getV2FiledSort, _yield$getV2FiledSort2, newData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (id) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                _context2.next = 4;
                return getV2FiledSortTmplFieldList({
                  tmplId: id,
                  type: 2
                });
              case 4:
                _yield$getV2FiledSort = _context2.sent;
                _yield$getV2FiledSort2 = _yield$getV2FiledSort.data;
                newData = _yield$getV2FiledSort2 === void 0 ? [] : _yield$getV2FiledSort2;
                newData.forEach(function (field) {
                  if (!field.is_system) {
                    var tmp = _this5.fieldList.find(function (v) {
                      return +v.id === +field.field_key;
                    }) || {};
                    field = Object.assign(field, tmp, {
                      fieldMap: tmp
                    });
                  }
                });
                _this5.fieldListBeta = newData;
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getFieldKey: function getFieldKey(item) {
      var _item$fieldMap;
      return item.is_system ? item.field_key : item === null || item === void 0 ? void 0 : (_item$fieldMap = item.fieldMap) === null || _item$fieldMap === void 0 ? void 0 : _item$fieldMap.type;
    },
    // 添加产品回显
    onCheckProduct: function onCheckProduct(list) {
      if (list) {
        var newList = this.productList.slice(0);
        list.forEach(function (item) {
          if (!newList.some(function (prod) {
            return prod.id === item.id;
          })) newList.push(item);
        });
        this.productList = newList;
      }
    },
    // 标题规则方法
    titleRuleFunc: function titleRuleFunc() {
      var _this6 = this;
      var title = this.titleRule;
      this.orderTitle.forEach(function (val) {
        if (val.indexOf('c|') !== -1) {
          var id = val.substring(2);
          if (_this6.customFields.some(function (item) {
            return Number(item.id) === Number(id);
          })) {
            _this6.customFields.forEach(function (val2) {
              if (Number(val2.id) === Number(id)) {
                if (val2.name) {
                  title = title.replace("{c|".concat(id, "}"), val2.name);
                } else {
                  title = title.replace("{c|".concat(id, "}"), '');
                }
              }
            });
          } else {
            title = title.replace("{c|".concat(id, "}"), '');
          }
        } else if (val.indexOf('s|') !== -1) {
          var obj = val.substring(2);
          _this6.titleRuleSystemFieldList.forEach(function (val2) {
            if (val2.key === obj) {
              if (_this6.systemFields[val2.obj]) {
                if (obj === 'fk_t_ep_service') {
                  if (_this6.template.service_name && _this6.id) {
                    title = title.replace("{".concat(val, "}"), _this6.template.service_name);
                  } else {
                    title = title.replace("{".concat(val, "}"), '');
                  }
                } else if (obj === 'custom_production') {
                  var productId = _this6.systemFields[val2.obj] ? _this6.systemFields[val2.obj].split(',') : [];
                  var productName = [];
                  _this6.productList.forEach(function (val3) {
                    if (productId.some(function (item) {
                      return Number(item) === Number(val3.id);
                    })) {
                      productName.push(val3.name);
                    }
                  });
                  title = title.replace("{".concat(val, "}"), productName.join('&'));
                } else if (obj === 'custom_apply_time') {
                  if (_this6.systemFields[val2.obj]) {
                    // 格式化日期数据
                    var time = new Date(utils.date.formatDate(_this6.systemFields[val2.obj])).Format('YYYY-MM-DD HH:mm');
                    title = title.replace("{".concat(val, "}"), time);
                  }
                } else if (obj === 'custom_name') {
                  // fix bug 1132
                  title = title.replace("{".concat(val, "}"), _this6.custom_name || _this6.systemFields.custom_name);
                } else {
                  title = title.replace("{".concat(val, "}"), _this6.systemFields[val2.obj]);
                }
              } else {
                title = title.replace("{".concat(val, "}"), '');
              }
            }
          });
        }
      });
      this.$set(this.systemFields, 'title', title);
    },
    // 选择地址
    selectAddress: function selectAddress(data) {
      this.systemFields.address_type = data.type;
      if (data.type === 1) {
        // 地图选址
        this.systemFields.custom_latitude = data.latitude;
        this.systemFields.custom_longitude = data.longitude;
        this.systemFields.map_name = data.address;
        this.systemFields.gps_addr = data.address;
      } else if (data.type === 2) {
        // 级联选择
        this.systemFields.prov_id = data.code[0];
        this.systemFields.city_id = data.code[1];
        this.systemFields.district_id = data.code[2];
        this.systemFields.street_id = data.code[3];
      }
    },
    // 表单验证
    formValidate: function formValidate() {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        var _this7$fieldListBeta$;
        if (!_this7.systemFields.title) {
          resolve({
            success: false,
            msg: i18n.tc("548")
          });
        }
        if (!_this7.systemFields.custom_phone) {
          resolve({
            success: false,
            msg: i18n.tc("549")
          });
        } else {
          if (!_this7.systemFields.custom_phone.match(/[0-9-()（）]{6,15}/)) {
            resolve({
              success: false,
              msg: i18n.tc("550")
            });
          }
        }
        if (!_this7.systemFields.custom_name) {
          resolve({
            success: false,
            msg: i18n.tc("551")
          });
        }
        if ((_this7$fieldListBeta$ = _this7.fieldListBeta.find(function (item) {
          return _this7.getFieldKey(item) === 'orderAppointment';
        })) !== null && _this7$fieldListBeta$ !== void 0 && _this7$fieldListBeta$.o_appointment_view && !_this7.systemFields.custom_apply_time) {
          resolve({
            success: false,
            msg: i18n.tc("552")
          });
        }
        if (_this7.fieldListBeta.some(function (item) {
          return _this7.getFieldKey(item) === 'orderAppointmentComplete';
        }) && !_this7.systemFields.EstimateCompleteTime) {
          resolve({
            success: false,
            msg: i18n.tc("553")
          });
        }
        if (_this7.template.o_service_address_view === 1 && !_this7.systemFields.address_type) {
          resolve({
            success: false,
            msg: i18n.tc("554")
          });
        }
        if (_this7.template.o_service_address_view === 1 && _this7.systemFields.address_type) {
          if (_this7.systemFields.address_type === 1 && !_this7.systemFields.map_name) {
            resolve({
              success: false,
              msg: i18n.tc("298")
            });
          } else if (_this7.systemFields.address_type === 2 && (!_this7.systemFields.prov_id || !_this7.systemFields.city_id)) {
            resolve({
              success: false,
              msg: i18n.tc("298")
            });
          }
        }
        resolve({
          success: true
        });
      });
    },
    // 新建工单表单提交
    submit: function submit() {
      var _this8 = this;
      // 系统字段表单验证
      this.formValidate().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
          var _this8$$refs$CustomFo, valid2, data;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!res.success) {
                    _context3.next = 12;
                    break;
                  }
                  if (!((_this8$$refs$CustomFo = _this8.$refs.CustomFormNode) !== null && _this8$$refs$CustomFo !== void 0 && _this8$$refs$CustomFo.map)) {
                    _context3.next = 7;
                    break;
                  }
                  _context3.next = 4;
                  return Promise.all(_this8.$refs.CustomFormNode.map(function (v) {
                    return v.formValidate();
                  }));
                case 4:
                  _context3.t0 = _context3.sent;
                  _context3.next = 8;
                  break;
                case 7:
                  _context3.t0 = [true];
                case 8:
                  valid2 = _context3.t0;
                  if (valid2.every(Boolean)) {
                    // 数据过滤
                    data = _objectSpread(_objectSpread({
                      service_id: _this8.id
                    }, _this8.systemFields), {}, {
                      priority: _this8.priority.join(','),
                      list: _this8.customFields.filter(Boolean).map(function (item) {
                        delete item.name;
                        return item;
                      }),
                      productId: _this8.productId,
                      customerProductionId: _this8.cpId,
                      // customerPro: this.customerPro, v494 deprecated
                      objectCustomerProductions: _this8.objectCustomerProductions,
                      fk_t_shop_order_goods_id: _this8.shopId,
                      fk_t_shop_order_id: _this8.shopOrderId
                    });
                    if (_this8.systemFields.address_type === 1) {
                      // map
                      data.prov_id = null;
                      data.city_id = null;
                      data.district_id = null;
                      data.street_id = null;
                    } else {
                      // select
                      data.custom_latitude = null;
                      data.custom_longitude = null;
                    }

                    // 详细地址
                    if (_this8.template.c_detailaddress_view === 0) {
                      data.custom_detail_addr = '';
                    }
                    // 预约时间关闭情况下 预约时间数据过滤
                    if (_this8.template.o_appointment_view === 0) {
                      data.custom_apply_time = '';
                    }
                    _this8.saveRequest(data);
                  }
                  _context3.next = 13;
                  break;
                case 12:
                  _this8.$vux.toast.text(res.msg);
                case 13:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    onConfirm: function onConfirm(val) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res, user;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return apiUpdateName({
                  name: val
                });
              case 2:
                res = _context4.sent;
                if (res.success) {
                  user = _objectSpread(_objectSpread({}, _this9.user), {}, {
                    name: val
                  });
                  _this9._user(user);
                } else {
                  _this9.$vux.toast.text(res.message);
                }
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    saveRequest: function saveRequest(data) {
      var _this10 = this;
      this.btnLoading = true;
      apiappointorder(data).then(function (res) {
        _this10.btnLoading = false;
        if (res.success) {
          if (_this10.user.name !== _this10.systemFields.custom_name) {
            _this10.onConfirm(_this10.systemFields.custom_name);
          }
          if (_this10.isEdit) {
            _this10.$vux.toast.text(i18n.tc("484"));
          } else {
            _this10.$vux.toast.text(i18n.tc("555"));
          }
          // reload order page
          _this10._pageReload({
            order: true
          });
          // 指派直接进入工单详情
          _this10.$router.push({
            name: 'Project'
          });
        } else {
          _this10.$vux.toast.text(res.message);
        }
      });
    },
    loadSet: function loadSet() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this11.productId) {
                  apicorporation({
                    productId: _this11.productId
                  }).then(function (res) {
                    if (res.success) {
                      _this11.productMap = res.data.productMap || {};
                    }
                  });
                }
                _context5.next = 3;
                return apisystemsettingByCode({
                  code: 40004
                }).then(function (res) {
                  if (res.success) {
                    _this11.isShowPriority = +res.data.value;
                  }
                });
              case 3:
                _context5.next = 5;
                return apisystemsettingByCode({
                  code: 20008
                }).then(function (res) {
                  if (res.success) {
                    _this11.OrderDefaultAddress = res.data.value ? res.data.value.split(',') : [];
                  }
                });
              case 5:
                _context5.next = 7;
                return apisystemsettingByCode({
                  code: 40017
                }).then(function (res) {
                  if (res.success) {
                    _this11.isShowCustomerInput = Number(res.data.value);
                  }
                });
              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }),
  // 初始化默认属性
  created: function created() {
    var _this12 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var _yield$apiproject, order, res, fieldListWithDropList, orderFiledlist, _yield$getV2FiledSort3, _yield$getV2FiledSort4, newData, _res, name, hasCache;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this12.loadSet();
            case 2:
              if (!_this12.oid) {
                _context6.next = 43;
                break;
              }
              _context6.next = 5;
              return apiproject({
                oid: _this12.oid
              });
            case 5:
              _yield$apiproject = _context6.sent;
              order = _yield$apiproject.data;
              _context6.next = 9;
              return apiorderbashinfo({
                service_id: _this12.id
              });
            case 9:
              res = _context6.sent;
              if (res.success) {
                _context6.next = 12;
                break;
              }
              return _context6.abrupt("return");
            case 12:
              _this12.customerList = res.data.customer_list || [];
              if (_this12.customerList.length && _this12.isShowCustomerInput) {
                _this12.custom_name = order.orderMap.custom_name;
                _this12.systemFields.fk_t_customer_id = order.orderMap.fk_t_customer_id; // todo
              }
              _this12.template = {
                o_appointment_view: res.data.o_appointment_view,
                o_descri_view: res.data.o_descri_view,
                o_img_view: res.data.o_img_view,
                o_service_address_view: res.data.o_service_address_view,
                c_detailaddress_view: res.data.c_detailaddress_view,
                service_name: res.data.service_name || '',
                o_priority_view: res.data.o_priority_view
              };
              _this12.systemFields.service_name = res.data.service_name || '';
              // let name = res.data.name || ''
              _this12.systemFields.custom_name = order.orderMap.custom_name;
              _this12.systemFields.custom_phone = order.orderMap.custom_phone;
              _this12.titleRule = res.data.o_ordername_rule || '';
              _this12.systemFields.custom_apply_time = order.orderMap.custom_apply_time;

              // 自定义字段
              fieldListWithDropList = res.data.list; // 带有dropList
              orderFiledlist = order.orderFiledlist || []; // 带有value
              _context6.next = 24;
              return getV2FiledSortTmplFieldList({
                tmplId: res.data.id,
                type: 2
              });
            case 24:
              _yield$getV2FiledSort3 = _context6.sent;
              _yield$getV2FiledSort4 = _yield$getV2FiledSort3.data;
              newData = _yield$getV2FiledSort4 === void 0 ? [] : _yield$getV2FiledSort4;
              // 排序的字段

              newData.forEach(function (field) {
                if (!field.is_system) {
                  var tmp = orderFiledlist.find(function (v) {
                    return +v.id === +field.field_key;
                  }) || {};
                  var tmp2 = fieldListWithDropList.find(function (v) {
                    return +v.id === +field.field_key;
                  }) || {};
                  field = Object.assign(field, {
                    fieldMap: Object.assign(tmp, tmp2, {
                      ovalue: tmp.drop_id ? tmp.drop_id.join(',') : tmp.value,
                      tfvvalue: tmp.value
                    })
                  });
                }
              });
              _this12.fieldListBeta = newData;
              _this12.systemFields.title = order.orderMap.title;
              // 地址回显
              _this12.systemFields.address_type = order.orderMap.address_type || 1;
              _this12.systemFields.custom_latitude = order.orderMap.custom_latitude || '';
              _this12.systemFields.custom_longitude = order.orderMap.custom_longitude || '';
              _this12.systemFields.map_name = order.orderMap.gps_addr || '';
              _this12.systemFields.gps_addr = order.orderMap.gps_addr || '';
              _this12.systemFields.custom_detail_addr = order.orderMap.custom_detail_addr || '';
              _this12.systemFields.prov_id = order.orderMap.prov_id || '';
              _this12.systemFields.city_id = order.orderMap.city_id || '';
              _this12.systemFields.district_id = order.orderMap.district_id || '';
              _this12.systemFields.street_id = order.orderMap.street_id || '';
              _this12.defaultCode = [_this12.systemFields.prov_id, _this12.systemFields.city_id, _this12.systemFields.district_id, _this12.systemFields.street_id];
              _context6.next = 73;
              break;
            case 43:
              _context6.next = 45;
              return apiorderbashinfo({
                service_id: _this12.id
              });
            case 45:
              _res = _context6.sent;
              if (_res.success) {
                _context6.next = 48;
                break;
              }
              return _context6.abrupt("return");
            case 48:
              _this12.customerList = _res.data.customer_list || [];
              if (_this12.customerList.length && _this12.isShowCustomerInput) {
                _this12.custom_name = _this12.customerList[0].name;
                _this12.systemFields.fk_t_customer_id = _this12.customerList[0].fk_t_customer_id;
              }
              _this12.template = {
                o_appointment_view: _res.data.o_appointment_view,
                o_descri_view: _res.data.o_descri_view,
                o_img_view: _res.data.o_img_view,
                o_service_address_view: _res.data.o_service_address_view,
                c_detailaddress_view: _res.data.c_detailaddress_view,
                service_name: _res.data.service_name || '',
                o_priority_view: _res.data.o_priority_view
              };
              _this12.systemFields.service_name = _res.data.service_name || '';
              name = _res.data.name || '';
              _this12.systemFields.custom_name = name.match(/\d{3}\*{4}\d+/) ? '' : name;
              _this12.systemFields.custom_phone = _res.data.phone || '';
              _this12.titleRule = _res.data.o_ordername_rule || '';
              _this12.fieldList = _res.data.list || [];
              _context6.next = 59;
              return _this12.initFieldList(_res.data.id);
            case 59:
              // 地址回显
              _this12.systemFields.address_type = _res.data.address_type || 1;
              _this12.systemFields.custom_latitude = _res.data.latitude || '';
              _this12.systemFields.custom_longitude = _res.data.longitude || '';
              _this12.systemFields.map_name = _res.data.map_name || '';
              _this12.systemFields.gps_addr = _res.data.gps_addr || '';
              _this12.systemFields.custom_detail_addr = _res.data.detail_addr || '';
              _this12.systemFields.prov_id = _res.data.prov_id || '';
              _this12.systemFields.city_id = _res.data.city_id || '';
              _this12.systemFields.district_id = _res.data.district_id || '';
              _this12.systemFields.street_id = _res.data.street_id || '';
              _this12.defaultCode = [_this12.systemFields.prov_id, _this12.systemFields.city_id, _this12.systemFields.district_id, _this12.systemFields.street_id];
              if (_this12.defaultCode.filter(Boolean).length === 0 && _this12.OrderDefaultAddress.length) {
                _this12.systemFields.address_type = 2;
                _this12.defaultCode = _this12.OrderDefaultAddress;
              }
              hasCache = _getCache(_this12.cacheKey);
              _this12.hasCache = Boolean(hasCache);
            case 73:
              if (_this12.cpId) {
                getCustomerProductDetail({
                  customerProductionId: _this12.cpId
                }).then(function (res) {
                  if (res.success) {
                    var customerPro = res.data.customerPro;
                    _this12.objectCustomerProductions.push({
                      customerProductionId: customerPro.id,
                      productName: customerPro.product_name,
                      production_sn: customerPro.production_sn,
                      faults: []
                    });
                  }
                });
              }
            case 74:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
};